// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__340ef","clinicsSelect":"TableHeading_clinicsSelect__3D0bl"};